import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";
import lifelog from "../../assets/lifelog.png";

const Logging = () => {
  return (
    <div className="blog">
      <div className="container">
        <div className="content">
          <Link to="/writings" className="back-link">
            ← back to writings
          </Link>
          <div className="blog-header-row">
            <div className="flex gap-4 items-center flex-row">
              <h1>what i learned from logging everyday of my life for 4 years</h1>
            </div>
            <p className="blog-date">2026-04-28</p>
          </div>
          <div className="border-b border-gray-400 text-gray-700 py-2">
            w.i.p
          </div>
          <div className="blog-content">
            <div className="blog-body">
              <img src={lifelog} alt="google sheet with a row logged for every day" className="blog-image" />

              <p>idk but there is prob some learning eventually</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logging;
